import styled from 'styled-components';

export const Section = styled.section`
  > div > canvas {
    height: ${(p) => p.height} !important;
    width: ${(p) => p.width} !important;
  }
`;
export const SvgContainer = styled.div`
  height: ${(p) => p.height} !important;
  width: ${(p) => p.width} !important;
`;
